import { HistoryItemPeriod, IHistoryItem } from "./../../interfaces/historyItem";
import { Injectable, ApplicationRef } from "@angular/core";
import { Subject, interval } from "rxjs";

import { IServiceRequest, IServiceRequestEx } from "../../interfaces/service.request";
import { IQuotaData } from "../../interfaces/quote.data";
import { IServiceResponse, LoginRs, RestoreSessionRs } from "../../interfaces/service.response";
import { IDataService } from "../../interfaces/service.dataService";
import * as moment from "moment";
import { LoginRequestModel } from "../../model/login.request.data";
import { map } from "rxjs/operators";
import { WakeUpService } from "../wakeUp.service";
import { ServicesClientEx } from "../../api/ServicesClientEx";
import { WorkspaceServiceService } from "../workspace-service.service";
import { GetProviderInfo, Providers } from "../../enums/providers";

//const URL: string = "ws://dev2.infosystrade.com:7170/quote";
export interface IAppSettings {
    WebSocketUrl: string; // "ws://dev2.infosystrade.com:7170/quote",
    SocketReconnect: number;
    SocketPingInterval: number; //10,
    SocketTimeout: number; //10,
    TrySendTimeout: number; //5
    TrySendCount: number; //5
    AllowPendingOrders: boolean;
    AllowScannerAccess: boolean;
    AllowScannerMobile: boolean;
    DebugVisibility: boolean;
    EnableAdSpace: boolean;
    GroupRequest: boolean;
    GroupRequestWebApi: boolean;
    LiveAccount: boolean;
}

@Injectable({
    providedIn: "root"
})
export class DataService implements IDataService {
    // public static TYPE_ADD: string = "add";
    // public static TYPE_DELETE: string = "delete";
    // public static TYPE_RESET: string = "reset";

    public static TYPE_GROUP_REQUEST: string = "GroupedRq";
    static TYPE_GROUP_RS: string = "GroupedRs";
    public static TYPE_GET_HISTORY_SYMBOL: string = "HistoricalDataReq";
    // public static TYPE_GET_HISTORY_SYMBOL_META: string = "history_period_meta";
    // public static TYPE_CANCEL_HISTORY_SYMBOL: string = "history_cancel";

    public static TYPE_LOGON: string = "LoginReq";
    public static TYPE_CREATEACCOUNT: string = "CreateAccountRq";
    public static TYPE_RENAMEACCOUNT: string = "RenameAccountRq";
    public static TYPE_DELETEACCOUNT: string = "DeleteAccountRq";
    public static TYPE_SWITCHACCOUNT: string = "SwitchAccountRq";
    public static TYPE_TOURNAMENTREGISTER: string = "TournamentRegisterRq";
    public static TYPE_LEADERBOARD: string = "LeaderBoardReq";
    public static TYPE_GET_CHALLENGE_HISTORY__ACCOUNT_LIST: string = "PreviousChallengesRequest";
    public static TYPE_GET_CHALLENGE_HISTORY_TRADE_LIST: string = "PrevChallengeTradeHistoryRq";
    public static TYPE_LOGOFF: string = "logoff";
    public static TYPE_SETALERTSTATE = "SetAlertStateRq";
    public static TYPE_CHANGEPASSWORD = "ChangePasswordReq";

    public static TYPE_TRADE: string = "OrderReq";

    public static TYPE_CANCELTRADE: string = "CancelReq";
    public static TYPE_CLOSETRADE: string = "CloseReq";
    public static TYPE_EDITTRADE: string = "EditRq";
    public static TYPE_PARTIACLOSE: string = "PartialCloseRq";
    public static TYPE_REPLACETRADE: string = "cxr";
    public static TYPE_SAVESETTING: string = "SaveSettingRq";
    public static TYPE_GETSETTINGS: string = "SettingsRq";
    public static TYPE_SWITCHPROVIDER: string = "SwitchProviderRq";

    public static TYPE_RESTORE_SESSION = "RestoreSessionRequest";

    public dataSubscriber: Subject<IServiceResponse> = new Subject<IServiceResponse>();

    private appSettings: IAppSettings = {
        WebSocketUrl: "ws://dev2.infosystrade.com:7170/quote",
        SocketReconnect: 5,
        SocketPingInterval: 20,
        SocketTimeout: 60,
        TrySendTimeout: 5,
        TrySendCount: 5,
        AllowPendingOrders: false,
        AllowScannerAccess: false,
        AllowScannerMobile: false,
        DebugVisibility: false,
        EnableAdSpace: false,
        GroupRequest: false,
        LiveAccount: false,
        GroupRequestWebApi: false
    };

    protected ws: WebSocket | undefined;

    public lastQuotes: { [id: string]: IQuotaData } = {};

    private _intervalData: any;
    private _intervalPingData: any;

    private _lastDataServerTime!: moment.Moment;
    public waitingForRestoreSession: boolean = false;
    public waitingForUserAccountCompleteInfo: boolean = true;

    public get lastDataServerTime(): moment.Moment {
        return this._lastDataServerTime;
    }
    public set lastDataServerTime(v: moment.Moment) {
        this._lastDataServerTime = v;
    }

    public loggedIn: boolean = false;

    public conectionOpened = false;

    public periodCache: {
        [symbol: string]: {
            [period: number]: {
                // HistoryItemPeriod
                minTimestamp: number;
                maxTimestamp: number;
                items: { [timestamp: number]: IHistoryItem };
            };
        };
    } = {};

    public historyRequests: { [id: string]: IServiceRequest | undefined } = {};

    public useWebsocketData: boolean = false;
    public mainService?: WorkspaceServiceService;
    public cookiesAccepted:boolean = false;
    constructor(
        protected app: ApplicationRef,
        protected wakeUp: WakeUpService,
        protected servicesClient: ServicesClientEx
    ) {
        if ((<any>window).appSettings) {
            this.appSettings = JSON.parse((<any>window).appSettings);
        }

        this.updateAppSettings(this.appSettings);

        this.connectToServer();

        this.wakeUp.wakeUpSubscriber.subscribe(() => {
            this.periodCache = {}; // clear period cache
            // this.connectToServer();
        });

        this.cookiesAccepted = localStorage.getItem('cookiesAccepted') == '1';
    }

    public updateAppSettings(appSettings: IAppSettings) {
        this.appSettings.SocketPingInterval = !isNaN(Number(appSettings.SocketPingInterval))
            ? appSettings.SocketPingInterval
            : 20;
        this.appSettings.SocketTimeout = !isNaN(Number(appSettings.SocketTimeout)) ? appSettings.SocketTimeout : 60;
        this.appSettings.SocketReconnect = !isNaN(Number(appSettings.SocketReconnect))
            ? appSettings.SocketReconnect
            : 5;

        this.appSettings.TrySendTimeout = !isNaN(Number(appSettings.TrySendTimeout)) ? appSettings.TrySendTimeout : 5;
        this.appSettings.TrySendCount = !isNaN(Number(appSettings.TrySendCount)) ? appSettings.TrySendCount : 5;

        this.appSettings.LiveAccount = appSettings.LiveAccount;
    }

    public get AllowPendingOrders() {
        return this.appSettings.AllowPendingOrders;
    }

    public get AllowScannerAccess() {
        return false;//this.appSettings.AllowScannerAccess;
    }

    public get AllowScannerMobile() {
        return this.appSettings.AllowScannerMobile;
    }

    public get DebugVisibility() {
        return this.appSettings.DebugVisibility;
    }

    public get EnableAdSpace() {
        return this.appSettings.EnableAdSpace;
    }

    public get LiveAccount() {
        return this.appSettings.LiveAccount;
    }

    protected connectToServer() {
        if (this._intervalData) {
            clearInterval(this._intervalData);
            this._intervalData = null;
        }

        if (this._intervalPingData) {
            clearInterval(this._intervalPingData);
            this._intervalPingData = null;
        }

        try {
            if (this.ws) {
                try {
                    this.ws.close();
                } catch {}
            }
            this.ws = undefined;
        } catch (error) {
            console.log(error);
        }

        try {
         //   this.appSettings.WebSocketUrl = "ws://prod.tradinghosting.com:7178";
            this.ws = new WebSocket(this.appSettings.WebSocketUrl);

            this.ws.onmessage = (msg: MessageEvent) => {
                this.lastDataServerTime = moment();
                let response: IServiceResponse = <IServiceResponse>JSON.parse(msg.data);
                if (response) {
                    if (response.Type == "LoginRs") {
                        setTimeout(() => {
                            this.processResponse(response);
                        }, 500);
                    } else {
                        if (this.mainService && GetProviderInfo(this.mainService.data.currentProvider).IsLocal) {
                            response.T = [];
                            response.P = [];
                            response.Periods = [];
                        }
                        this.processResponse(response);
                    }
                }
                return true;
            };
            this.ws.onerror = (ev: Event) => {
                if (this.ws) {
                    try {
                        this.ws.close();
                        this.ws = undefined;
                    } catch {
                        this.ws = undefined;
                    }
                    setTimeout(() => {
                        this.connectToServer();
                    }, 1000 * this.appSettings.SocketReconnect);
                }
                return true;
            };

            this.ws.onopen = (ev: Event) => {
                this.conectionOpened = true;
                this.lastDataServerTime = moment();
                // check if time from last msg from socket is greater then 20 sec
                this._intervalData = setInterval(() => {
                    let tmp = moment().diff(this.lastDataServerTime, "second");
                    if (tmp > this.appSettings.SocketPingInterval) {
                        try {
                            if (this.ws) {
                                this.ws.close();
                                this.ws = undefined;
                            }
                        } catch {
                            this.ws = undefined;
                        }

                        if (this._intervalData) {
                            clearInterval(this._intervalData);
                            this._intervalData = null;
                        }
                        if (this._intervalPingData) {
                            clearInterval(this._intervalPingData);
                            this._intervalPingData = null;
                        }
                        this.connectToServer();
                    }
                }, 1000 * this.appSettings.SocketTimeout);

                //    this.pingDataSocket();

                if (this._seesionKey && this._seesionKey != "") {
                    this.periodCache = {};
                    this.waitingForRestoreSession = true;
                    this.sendRequest({
                        Cmd: DataService.TYPE_RESTORE_SESSION,
                        Data: {
                            SessionKey: this._seesionKey
                        }
                    });
                }

                return true;
            };
        } catch {
            if (this.ws) {
                try {
                    this.ws.close();
                    this.ws = undefined;
                } catch {
                    this.ws = undefined;
                }
                if (this._intervalData) {
                    clearInterval(this._intervalData);
                    this._intervalData = null;
                }
                if (this._intervalPingData) {
                    clearInterval(this._intervalPingData);
                    this._intervalPingData = null;
                }
                setTimeout(() => {
                    this.connectToServer();
                }, 1000 * this.appSettings.SocketTimeout);
            }
        }
    }
    processResponse(response: IServiceResponse) {
        if (response) {
            if (response.Type == DataService.TYPE_GROUP_RS) {
                if (response.Data && Array.isArray(response.Data))
                    response.Data.forEach(res => {
                        this.processResponse(res);
                    });
            } else {
                this.verifyIsLogin(response);

                this.processRestoreSessionRs(response);
                if (!this.waitingForRestoreSession) {
                    if (response.T) {
                        response.T.forEach((value, i, a) => {
                            this.lastQuotes[value.S] = value;
                        });
                    }

                    this.processHistoryResponse(response)
                        .then(() => {
                            this.dataSubscriber.next(response);
                            delete this.historyRequests[response.ReqID!];
                            delete response.Periods;
                            delete response.T;
                            delete response.Text;
                        })
                        .catch(e => {
                            console.error(e);
                        });
                    /*
                    .finally(() => {
                        delete response.Periods;
                        delete response.T;
                        delete response.Text;
                    })*/

                    if (response.P) {
                        // try update local cache periods
                        response.P.forEach(p => {
                            if (this.periodCache[p.Symbol] && this.periodCache[p.Symbol][p.PeriodType]) {
                                let symbolPeriodCache = this.periodCache[p.Symbol][p.PeriodType];
                                symbolPeriodCache.items[p.Period.t] = p.Period;
                                symbolPeriodCache.maxTimestamp =
                                    symbolPeriodCache.maxTimestamp < p.Period.t
                                        ? p.Period.t
                                        : symbolPeriodCache.maxTimestamp;
                                symbolPeriodCache.minTimestamp =
                                    symbolPeriodCache.minTimestamp > p.Period.t
                                        ? p.Period.t
                                        : symbolPeriodCache.minTimestamp;
                                this.periodCache[p.Symbol][p.PeriodType] = symbolPeriodCache;
                            }
                        });
                    }
                }
            }
        }
    }

    private async processHistoryResponse(response: IServiceResponse) {
        if (
            response.Type == "HistoricalDataRs" &&
            Object.keys(this.historyRequests).indexOf(response.ReqID || "") >= 0
        ) {
            let symbol = response.Symbol || "";
            let period = response.Period != null ? response.Period : HistoryItemPeriod.Unknown;
            let periods = response.Periods || [];
            let symbolCache = this.periodCache[symbol];
            let items: IHistoryItem[] = [];
            if (symbolCache) {
                let symbolPeriodCache = symbolCache[period];
                if (symbolPeriodCache) {
                    items = Object.keys(symbolPeriodCache.items).map(k => symbolPeriodCache.items[Number(k)]);
                }
            } else {
                symbolCache = {};
            }

            items = items.concat(periods);

            for (var i = 0; i < items.length; ++i) {
                for (var j = i + 1; j < items.length; ++j) {
                    if (items[i].t === items[j].t) items.splice(j--, 1);
                }
            }
            items = items.sort((a, b) => {
                return a.t > b.t ? 1 : a.t < b.t ? -1 : 0;
            });
            let obj_items: any = {};
            items.forEach(p => {
                obj_items[p.t] = p;
            });
            symbolCache[period] = {
                maxTimestamp: Math.max(...items.map(x => x.t)),
                minTimestamp: Math.min(...items.map(x => x.t)),
                items: obj_items
            };
            this.periodCache[symbol] = symbolCache;
            let requestsId = Object.keys(this.historyRequests);
            requestsId.forEach(rId => {
                if (this.historyRequests[rId]) {
                    let request: IServiceRequest = this.historyRequests[rId] as IServiceRequest;
                    if (
                        request.Data.Symbol == symbol &&
                        request.Data.Period == period &&
                        request.Data.ReqID == rId &&
                        response.ReqID != rId
                    ) {
                        this.responseFromLocal(rId, symbol, period, request.Data.Points);
                    }
                }
            });
        }
    }

    protected pingDataSocket() {
        if (this._intervalPingData) {
            clearInterval(this._intervalPingData);
            this._intervalPingData = null;
        }

        this._intervalPingData = setInterval(() => {
            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                this.ws.send(JSON.stringify(pingRequest));
            } else if (
                this.ws &&
                (this.ws.readyState === WebSocket.CLOSED || this.ws.readyState === WebSocket.CLOSING)
            ) {
                if (this._intervalPingData) {
                    clearInterval(this._intervalPingData);
                    this._intervalPingData = null;
                }
                this.connectToServer();
            }
        }, 1000 * 5); //this.appSettings.SocketPingInterval);
    }

    protected send(request: IServiceRequest, errorCallback?: (error: any) => void): void {
        let data: string = request.Cmd + JSON.stringify(request.Data);
        try {
            if (this.ws && this.ws.readyState == WebSocket.OPEN) {
                this.ws.send(data);
            } else {
                var trycount = 1000;
                var handle = setInterval(() => {
                    if (trycount > 0) {
                        try {
                            if (this.ws && this.ws.readyState == WebSocket.OPEN) {
                                this.ws.send(data);
                                clearInterval(handle);
                            }
                        } catch (err) {}
                    }
                    trycount--;
                    if (trycount < 0) {
                        clearInterval(handle);
                    }
                }, 100);
            }
        } catch (err) {
            var trycount = 1000;
            var handle = setInterval(() => {
                if (trycount > 0) {
                    try {
                        if (this.ws && this.ws.readyState == WebSocket.OPEN) {
                            this.ws.send(data);
                            clearInterval(handle);
                        }
                    } catch (err) {}
                }
                trycount--;
                if (trycount < 0) {
                    clearInterval(handle);
                }
            }, 100);
        }
    }

    sendRequest(request: IServiceRequest): void {
        if (request) {
            var currentProviderInfo = this.mainService
                ? GetProviderInfo(this.mainService.data.currentProvider)
                : undefined;
            if (request.Cmd == DataService.TYPE_SWITCHPROVIDER) {
                if (currentProviderInfo && currentProviderInfo.IsLocal && currentProviderInfo.Provider) {
                    currentProviderInfo.Provider.SwitchOff();
                    this.send(request);
                    return;
                }
            }

            if (request.Cmd == DataService.TYPE_LOGON || request.Cmd == DataService.TYPE_RESTORE_SESSION) {
                this.send(request);
                return;
            }

            if (request.Cmd == DataService.TYPE_SWITCHACCOUNT && !GetProviderInfo(request.Data.Provider).IsLocal) {
                this.send(request);
                return;
            }


            if (currentProviderInfo && currentProviderInfo.IsLocal && currentProviderInfo.Provider) {
                switch (request.Cmd) {
                    case DataService.TYPE_TRADE:
                        currentProviderInfo.Provider.OrderRequest(request.Data);
                        break;
                    case DataService.TYPE_CANCELTRADE:
                        currentProviderInfo.Provider.CancelOrder(request.Data);
                        break;
                    case DataService.TYPE_EDITTRADE:
                        currentProviderInfo.Provider.EditOrder(request.Data);
                        break;
                    case DataService.TYPE_CLOSETRADE:
                        currentProviderInfo.Provider.CloseTrade(request.Data);
                        break;

                    case DataService.TYPE_SWITCHACCOUNT:
                        currentProviderInfo.Provider.SwitchAccount(request.Data);
                        break;
                }
            } else {
                this.send(request);
            }
        }
    }

    switchProvider(provider: string) {
        return new Promise((resolve, reject) => {
            let subscriber = this.dataSubscriber.subscribe(response => {
                if (response.Type == "SwitchProviderRs") {
                    if ((response as any).Error == null) {
                        resolve((response as any).Accounts);
                    } else {
                        reject((response as any).Error);
                    }

                    subscriber.unsubscribe();
                }
            });
            this.sendRequest({ Cmd: "SwitchProviderRq", Data: { Provider: provider } });
        });
    }

    getProviderPeriods() {
        var providerInfo =
            this.mainService && this.mainService.data
                ? GetProviderInfo(this.mainService.data.currentProvider)
                : undefined;
        let periods: HistoryItemPeriod[] = [];
        if (providerInfo && providerInfo.IsLocal && providerInfo.Provider) {
            periods = providerInfo.Provider.GetProviderIntervalsInfo();
        }
        return periods;
    }

    getProviderTransactions(dateFromUTC: string, dateToUTC: string) {
        return new Promise((resolve, reject) => {
            let subscriber = this.dataSubscriber.subscribe(response => {
                if (response.Type == "GetProviderTransactionsRs") {
                    if ((response as any).Error == null) {
                        resolve(response);
                    } else {
                        reject((response as any).Error);
                    }

                    subscriber.unsubscribe();
                }
            });
            this.sendRequest({
                Cmd: "GetProviderTransactionsRq",
                Data: { DateFromUTC: dateFromUTC, DateToUTC: dateToUTC }
            });
        });
    }

    public chartRequestsCount: number = 0;
    public canSendRequest: boolean = false;

    sendHistoryRequest(
        symbol: string,
        period: HistoryItemPeriod,
        limit: number = 2000,
        chartRequest: boolean = false
    ): Promise<string> {
        return new Promise<string>((rs, rj) => {
            if (
                !this._seesionKey ||
                this._seesionKey == "" ||
                this.waitingForRestoreSession ||
                this.ws == undefined ||
                this.ws.readyState !== WebSocket.OPEN ||
                this.waitingForUserAccountCompleteInfo
            ) {
                // waiting for session key !
                var waitCount = 10000;
                var interval = setInterval(() => {
                    if (
                        this.waitingForRestoreSession == false &&
                        this._seesionKey &&
                        this._seesionKey != "" &&
                        !this.waitingForUserAccountCompleteInfo
                    ) {
                        // call self and close interval
                        clearInterval(interval);
                        this.sendHistoryRequest(symbol, period, limit, chartRequest)
                            .then(r => rs(r))
                            .catch(r => rj(r));
                    }
                    waitCount--;
                    if (waitCount < 0) {
                        clearInterval(interval);
                        // ??? what now ???
                    }
                }, 100);
            } else {
                if (chartRequest && this.canSendRequest) {
                    this.chartRequestsCount++;
                }
                let res = `H${chartRequest ? "C" : ""}_${symbol}${Date.now().toString()}${Math.random()}`;

                let symbol_period = `${symbol}_${period}`;
                let old_requests = Object.keys(this.historyRequests)
                    .filter(x => x != res)
                    .map(k => `${this.historyRequests[k]!.Data.Symbol}_${this.historyRequests[k]!.Data.Period}`);

                this.historyRequests[res] = {
                    Cmd: DataService.TYPE_GET_HISTORY_SYMBOL,
                    Data: {
                        Period: period,
                        Symbol: symbol,
                        ReqID: res,
                        Points: limit // orginal limit
                    }
                };

                // two requests in the same time or search local cache for symbol/period
                if (
                    old_requests.filter(x => x == symbol_period).length > 0 ||
                    (this.periodCache[symbol] && this.periodCache[symbol][period])
                ) {
                    rs(res);

                    setTimeout(() => {
                        this.responseFromLocal(res, symbol, period, limit);
                    }, 50);
                } else {
                    // send request for maximum points
                    this.sendRequestAndTryGroup({
                        Cmd: DataService.TYPE_GET_HISTORY_SYMBOL,
                        Data: {
                            Period: period,
                            Symbol: symbol,
                            ReqID: res,
                            Points: limit < 2000 ? 2000 : limit
                        }
                    });
                    rs(res);
                }
            }
        });
    }

    private requestsForGroup: IServiceRequest[] = [];
    private sendGroupInterval: any | undefined;

    private sendRequestAndTryGroup(request: IServiceRequest) {
        if (this.appSettings.GroupRequest == true) {
            this.requestsForGroup.push(request);
            if (!this.sendGroupInterval) {
                this.sendGroupInterval = setInterval(() => {
                    this.sendGroupedRequest();
                }, 100);
            }
            if (this.requestsForGroup.length > 20 && this.canSendRequest == true) {
                this.sendGroupedRequest();
            }
        } else {
            this.sendRequest(request);
        }
    }

    private _visibleCharts: number = 0;
    public get visibleCharts() {
        return this._visibleCharts;
    }
    public set visibleCharts(v: number) {
        v = v < 0 ? 0 : v;
        v = v > 4 ? 4 : v;
        this._visibleCharts = v;
    }

    private async sendGroupedRequest() {
        if (this.chartRequestsCount < this.visibleCharts) return;

        var tmp = this.requestsForGroup;
        this.requestsForGroup = [];

        var tmp1 = tmp.filter(r => r.Data && r.Data.ReqID.startsWith("HC_") == true);
        var tmp2 = tmp.filter(r => r.Data && r.Data.ReqID.startsWith("HC_") == false);
        if (tmp1.length > 0) {
            tmp = tmp1;
            setTimeout(() => {
                tmp2.forEach(r => {
                    this.sendRequestAndTryGroup(r);
                });
            }, 10);
        }

        if (tmp && tmp.length > 0) {
            var historicalDataRequests = tmp.map(r => r.Data);
            var providerInfo = this.mainService ? GetProviderInfo(this.mainService.data.currentProvider) : undefined;
            if (providerInfo && providerInfo.IsLocal && this.mainService && providerInfo.Provider) {
                console.log("[historicalDataRequests,this.mainService.data.providerInstruments]");
                console.log([historicalDataRequests, this.mainService.data.providerInstruments]);
                historicalDataRequests = historicalDataRequests.filter(v => {
                    if (this.mainService) {
                        return this.mainService.GainService.nameDictionary[v.Symbol] !== undefined;
                    }

                    return true;
                });

                providerInfo.Provider.HistoricalData(historicalDataRequests);
            } else {
                if (this.appSettings.GroupRequestWebApi == true) {
                    this.servicesClient
                        .groupedRequestEx(historicalDataRequests, this._seesionKey)
                        .toPromise()
                        .then(res => {
                            this.processResponse(res);
                        });
                } else {
                    var request: IServiceRequest = {
                        Cmd: DataService.TYPE_GROUP_REQUEST,
                        Data: {
                            Data: historicalDataRequests
                        }
                    };
                    this.sendRequest(request);
                }
            }
        }
    }

    private async responseFromLocal(
        requestId: string,
        symbol: string,
        period: HistoryItemPeriod,
        limit: number = 2000
    ) {
        this.tryToGetFromCache(symbol, period, limit)
            .then(r => {
                r.ReqID = requestId;
                if (this.historyRequests[requestId]) {
                    delete this.historyRequests[requestId];
                    this.dataSubscriber.next(r);
                }
            })
            .catch(e => {
                //  console.log(e);
            });
    }

    tryToGetFromCache(symbol: string, period: HistoryItemPeriod, limit: number = 2000): Promise<IServiceResponse> {
        return new Promise<IServiceResponse>((rs, rj) => {
            if (this.periodCache[symbol] && this.periodCache[symbol][period]) {
                let response_items: IHistoryItem[] = [];
                let symbolCache = this.periodCache[symbol];
                let symbolPeriodCache = symbolCache[period];

                response_items = Object.keys(symbolPeriodCache.items).map(k => symbolPeriodCache.items[Number(k)]);
                response_items = response_items.slice(
                    response_items.length > limit ? response_items.length - limit : 0
                );

                response_items = response_items.sort((a, b) => {
                    return a.t < b.t ? 1 : a.t > b.t ? -1 : 0;
                });

                let local_response: IServiceResponse = {
                    Type: "HistoricalDataRs",
                    ReqID: "OK",
                    Symbol: symbol,
                    Period: period,
                    Periods: response_items
                };

                // console.log(`local_response ${symbol} ${period} ${limit}`);
                // console.log(local_response);

                rs(local_response);
            } else {
                rj("not exists in cache");
            }
        });
    }

    trySendLogin() {
        var userName = window.sessionStorage.getItem("userName");
        var userPassword = window.sessionStorage.getItem("userPassword");
        if (userName && userPassword && userName != "" && userPassword != "") {
            let logon: LoginRequestModel = new LoginRequestModel();
            logon.Password = userPassword;
            logon.Username = userName;
            this.sendRequest({
                Cmd: DataService.TYPE_LOGON,
                Data: logon
            });
        }
    }

    private _seesionKey: string = "";
    verifyIsLogin(response: IServiceResponse) {
        if (response) {
            switch (response.Type) {
                case "LoginRs":
                    var loginRs: LoginRs = <LoginRs>response;
                    if (loginRs.OK == true) {
                        if (loginRs.Provider == "OANDA" && loginRs.IsProviderBound == false) {
                            //alert("BOUDNS NO");
                            //  this.hideApp = true;
                        }
                        this._seesionKey = loginRs.SessionKey;
                        this.waitingForRestoreSession = false;
                    }
                    break;
            }
        }
    }

    private _hideApp: boolean = false;
    public get hideApp(): boolean {
        return this._hideApp;
    }
    public set hideApp(value: boolean) {
        this._hideApp = value;
    }

    public getSessionKey(): string {
        return this._seesionKey;
    }

    private processRestoreSessionRs(response: IServiceResponse) {
        if (response) {
            switch (response.Type) {
                case "RestoreSessionRs":
                    var restoreSessionRs: RestoreSessionRs = <RestoreSessionRs>response;
                    if (restoreSessionRs.Error && restoreSessionRs.Error != "") {
                        this._seesionKey = "";
                        this.trySendLogin();
                    }
                    this.periodCache = {}; // always reset catche
                    this.waitingForRestoreSession = false;
                    break;
            }
        }
    }

    private _currentlyChanged: string = "";
    public get currentlyChanged(): string {
        return this._currentlyChanged;
    }
    public set currentlyChanged(value: string) {
        this._currentlyChanged = value;
    }
}

const pingRequest: IServiceRequest = {
    Cmd: "ping"
};

export const initRequest: IServiceRequest = {
    Cmd: "reset",
    Symbols: [
        "AUD/CAD",
        "AUD/CHF",
        "AUD/JPY",
        "AUD/NZD",
        "AUD/USD",
        "BTC/EUR",
        "BTC/JPY",
        "BTC/USD",
        "CAD/CHF",
        "CAD/JPY",
        "CHF/HUF",
        "CHF/JPY",
        "EUR/AUD",
        "EUR/CAD",
        "EUR/CHF",
        "EUR/DKK",
        "EUR/GBP",
        "EUR/HUF",
        "EUR/ILS",
        "EUR/JPY",
        "EUR/NOK",
        "EUR/NZD",
        "EUR/PLN",
        "EUR/RUB",
        "EUR/SEK",
        "EUR/TRY",
        "EUR/USD",
        "EUR/ZAR",
        "GBP/AUD",
        "GBP/CAD",
        "GBP/CHF",
        "GBP/HUF",
        "GBP/ILS",
        "GBP/JPY",
        "GBP/NZD",
        "GBP/SEK",
        "GBP/SGD",
        "GBP/USD",
        "NZD/CAD",
        "NZD/CHF",
        "NZD/JPY",
        "NZD/USD",
        "TRY/JPY",
        "USD/AED",
        "USD/ANG",
        "USD/ARS",
        "USD/AUD",
        "USD/BDT",
        "USD/BGN",
        "USD/BHD",
        "USD/BND",
        "USD/BOB",
        "USD/BRL",
        "USD/BWP",
        "USD/CAD",
        "USD/CHF",
        "USD/CLP",
        "USD/CNH",
        "USD/CNY",
        "USD/COP",
        "USD/CRC",
        "USD/CZK",
        "USD/DKK",
        "USD/DOP",
        "USD/DZD",
        "USD/EGP",
        "USD/EUR",
        "USD/FJD",
        "USD/GBP",
        "USD/HKD",
        "USD/HNL",
        "USD/HRK",
        "USD/HUF",
        "USD/IDR",
        "USD/ILS",
        "USD/INR",
        "USD/JMD",
        "USD/JOD",
        "USD/JPY",
        "USD/KES",
        "USD/KRW",
        "USD/KWD",
        "USD/KYD",
        "USD/KZT",
        "USD/LBP",
        "USD/LKR",
        "USD/LTL",
        "USD/LVL",
        "USD/MAD",
        "USD/MDL",
        "USD/MKD",
        "USD/MUR",
        "USD/MVR",
        "USD/MXN",
        "USD/MYR",
        "USD/NAD",
        "USD/NGN",
        "USD/NIO",
        "USD/NOK",
        "USD/NPR",
        "USD/NZD",
        "USD/OMR",
        "USD/PEN",
        "USD/PGK",
        "USD/PHP",
        "USD/PKR",
        "USD/PLN",
        "USD/PYG",
        "USD/QAR",
        "USD/RON",
        "USD/RSD",
        "USD/RUB",
        "USD/SAR",
        "USD/SCR",
        "USD/SEK",
        "USD/SGD",
        "USD/SLL",
        "USD/THB",
        "USD/TND",
        "USD/TRY",
        "USD/TTD",
        "USD/TWD",
        "USD/TZS",
        "USD/UAH",
        "USD/UGX",
        "USD/USD",
        "USD/UYU",
        "USD/UZS",
        "USD/VEF",
        "USD/VND",
        "USD/XOF",
        "USD/YER",
        "USD/ZAR",
        "XAG/USD",
        "XAU/USD"
    ],
    initOrder: [
        "AUD/CAD",
        "AUD/JPY",
        "AUD/NZD",
        "AUD/USD",
        "CAD/JPY",
        "CHF/JPY",
        "EUR/AUD",
        "EUR/CAD",
        "EUR/CHF",
        "EUR/GBP",
        "EUR/JPY",
        "EUR/USD",
        "GBP/CHF",
        "GBP/JPY",
        "GBP/USD",
        "NZD/JPY",
        "NZD/USD",
        "USD/CAD",
        "USD/CHF",
        "USD/HKD",
        "USD/JPY"
    ]
};

export const symbolsForexOrder: string[] = ["AUD/USD", "GBP/USD", "EUR/USD", "USD/CAD", "USD/CHF", "USD/JPY"];

export function getSymbolOrder(symbol: string, _symbolsOrder: string[]) {
    const symbolOrder = _symbolsOrder.indexOf(symbol);
    return symbolOrder == -1 ? Number.MAX_VALUE : symbolOrder;
}
